export default class LoadExternMedia {
  constructor () {
    const elements = document.querySelectorAll<HTMLElement>('[data-src]')

    if (elements.length > 0) {
      this.init(elements)
    }
  }

  private init (elements: NodeListOf<HTMLElement>): void {
    elements.forEach(this.addingBlocker.bind(this))
  }

  private openFingerPrintBtn (): void {
    const button = document.querySelector<HTMLElement>('.cookies-fingerprint-btn')
    button?.click()
  }

  private addingBlocker (element: HTMLElement): void {
    const parent = element.localName === 'iframe' ? element.parentElement : element.parentElement?.parentElement
    parent?.addEventListener('click', this.openFingerPrintBtn.bind(this))
    parent?.classList.add('consent-window')
  }

  private removingBlocker (element: HTMLElement): void {
    const parent = element.localName === 'iframe' ? element.parentElement : element.parentElement?.parentElement
    parent?.removeEventListener('click', this.openFingerPrintBtn.bind(this))
    parent?.classList.remove('consent-window')
  }

  public resetSrc (): void {
    document.querySelectorAll('iframe').forEach(element => {
      const dataSrc = element.getAttribute('data-src')

      if (element.src !== '' && dataSrc === null) {
        this.addingBlocker(element)
        element.setAttribute('data-src', element.src)
        element.src = ''
      }
    })
  }

  public load (): void {
    document.querySelectorAll<HTMLElement>('[data-src]').forEach(element => {

      this.removingBlocker(element)
      element.setAttribute('src', element.getAttribute('data-src') ?? '')

      if (element.parentElement && 'load' in element.parentElement && typeof element.parentElement.load === 'function') {
        element.parentElement.load()
      }
    })
  }
}